import { Engine } from "../engine/Engine";

export function engineRequestAfter(
  func?: Function,
  dispose?: boolean
) {
  const obj = {
    callback: func,
    dispose: dispose,
  };
  const event = new CustomEvent("engine-request-after", {
    detail: obj,
  });
  Engine.activeEngine.dispatchEvent(event);
  return obj;
}

export function engineRequestBefore(
  func?: Function,
  dispose?: boolean
) {
  const obj = {
    callback: func,
    dispose: dispose,
  };
  const event = new CustomEvent("engine-request-before", {
    detail: obj,
  });
  Engine.activeEngine.dispatchEvent(event);
  return obj;
}

export function cameraGo2d() {
  const event = new CustomEvent("camera-go-2d", {});
  Engine.activeEngine.dispatchEvent(event);
}
